export const InternalProperties = {
    SELECTED: "__selected",
    SHOULD_SHOW: "__shouldShow",
    INLINE_EDIT: "__inEdit"
}